import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ModalLogin from '../ui/ModalLogin';
import ModalRegistro from '../ui/ModalRegistro';
import api from '../../utils/api';
import logo from '../../assets/logo.png';
import './Navbar.css';

export default function Navbar() {
  const auth = useAuth();
  const { usuario, logout, esMaestro, esAdmin, logueado } = auth;

  const nav = useNavigate();
  const [showLogin, setShowLogin]     = useState(false);
  const [showRegistro, setShowRegistro] = useState(false);
  const [pending, setPending] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  React.useEffect(() => {
    if (!usuario) return;
    const check = () => api.get('/usuarios/notificaciones').then(r => setPending(r.data.total)).catch(()=>{});
    check();
    const t = setInterval(check, 30000); // 30s (más reactivo)
    return () => clearInterval(t);
  }, [usuario]);

  const ini = usuario
    ? ((usuario.nombre || usuario.email || '?')[0] + (usuario.apellido?.[0] || '')).toUpperCase()
    : '';

  const rolBadge = { admin: 'badge-admin', maestro: 'badge-maestro', estudiante: 'badge-green', publico: 'badge-green' };
  const rolLabel = { admin: 'Admin', maestro: 'Maestro', estudiante: 'Estudiante', publico: 'Público' };

  return (
    <>
      <nav className="navbar-glass fade-up">
        <div className="nb-container">
          <div className="nb-logo" onClick={() => nav('/')}>
            <div className="nb-icon-box bg-transparent shadow-none">
              <img src={logo} alt="Logo" className="w-full h-full object-contain" />
            </div>
            <div className="nb-text-box">
              <div className="nb-brand">Red<span>Cimarrona</span></div>
              <div className="nb-tagline">Comunidad Universitaria</div>
            </div>
          </div>

          <div className={`nb-nav${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(false)}>
            <NavLink to="/"            className={({isActive})=>`nb-item${isActive?' active':''}`} end>Inicio</NavLink>
            <NavLink to="/animales"    className={({isActive})=>`nb-item${isActive?' active':''}`}>Adopción</NavLink>
            <NavLink to="/calendario"  className={({isActive})=>`nb-item${isActive?' active':''}`}>Calendario</NavLink>
            <NavLink to="/ranking"     className={({isActive})=>`nb-item${isActive?' active':''}`}>Ranking</NavLink>
            <NavLink to="/donaciones"  className={({isActive})=>`nb-item${isActive?' active':''}`}>Donar</NavLink>
            <NavLink to="/reporte"     className={({isActive})=>`nb-item${isActive?' active':''}`}>Reportar</NavLink>
            {usuario && (
              <NavLink to="/panel" className={({isActive})=>`nb-item${isActive?' active':''}`}>
                {esAdmin ? 'Administración' : esMaestro ? 'Gestión' : 'Mi Cuenta'}
              </NavLink>
            )}
          </div>

          <div className="nb-actions">
            <button
              className={`nb-burger${menuOpen ? ' open' : ''}`}
              onClick={() => setMenuOpen(o => !o)}
              aria-label="Menú"
              aria-expanded={menuOpen}
            >
              <span></span><span></span><span></span>
            </button>
            {usuario ? (
              <div className="nb-user-group">
                <div className="nb-profile" onClick={() => nav('/panel')}>
                  {usuario.avatar ? (
                    <div className="nb-avatar">
                      <img src={usuario.avatar} alt="Me" className="w-full h-full object-cover" />
                      {pending > 0 && <div className="nb-pulse-dot" title={`${pending} pendientes`} aria-label={`${pending} pendientes`} />}
                    </div>
                  ) : (
                    <div className="nb-avatar">
                      {ini}
                      {pending > 0 && <div className="nb-pulse-dot" title={`${pending} pendientes`} aria-label={`${pending} pendientes`} />}
                    </div>
                  )}
                  <span className="nb-name">{usuario.nombre}</span>
                </div>
                <button className="btn btn-ghost btn-sm" onClick={logout}>Salir</button>
              </div>
            ) : (
              <div className="nb-auth-btns">
                <button className="nb-login-btn" onClick={() => setShowLogin(true)}>Entrar</button>
                <button className="btn btn-v btn-sm" onClick={() => setShowRegistro(true)}>Unirme</button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {showLogin    && <ModalLogin    onClose={()=>setShowLogin(false)}    onSwitch={()=>{setShowLogin(false);setShowRegistro(true);}} />}
      {showRegistro && <ModalRegistro onClose={()=>setShowRegistro(false)} onSwitch={()=>{setShowRegistro(false);setShowLogin(true);}} />}
    </>
  );
}
